import { render } from "./Template3View.vue?vue&type=template&id=476ac076"
import script from "./Template3View.vue?vue&type=script&lang=js"
export * from "./Template3View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__